(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name trainingPrograms.controller:TrainingAssignCrewCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .controller('TrainingAssignCrewCtrl', TrainingAssignCrewCtrl);

    function TrainingAssignCrewCtrl(modalParams, $uibModalInstance, TrainingAssignCrewLogic) {
        var vm = this;
        vm.selectedTraining = modalParams.selectedTraining;
        vm.selectedTraining.trainingProgramID =
            (vm.selectedTraining &&
            vm.selectedTraining.subPrograms &&
            vm.selectedTraining.subPrograms[0] &&
            vm.selectedTraining.subPrograms[0].subProgramId) || null;

        TrainingAssignCrewLogic.setSelectedTraning(modalParams.selectedTraining);
        TrainingAssignCrewLogic.getTrainingDetails(vm.selectedTraining && vm.selectedTraining.trainingSlotID);

        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };
    }
}());
